var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10481_24057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.99 8C12.47 8 8 12.48 8 18C8 23.52 12.47 28 17.99 28C23.52 28 28 23.52 28 18C28 12.48 23.52 8 17.99 8ZM18 26C13.58 26 10 22.42 10 18C10 13.58 13.58 10 18 10C22.42 10 26 13.58 26 18C26 22.42 22.42 26 18 26Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13H17V19L22.25 22.15L23 20.92L18.5 18.25V13Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10481_24057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.584b4dd743d6c1d5cdd17b5553b20b34.svg";
export { ForwardRef as ReactComponent };